<template>
	<div style="box-sizing: border-box;padding: 10px;min-height: 100%;" v-loading="loading">
		<div style="margin-bottom: 100px;">
			<v-jstree ref="jstree" size="small" text-field-name="name" value-field-name="id" :data="departmentlist" 
				@item-click="itemClick" v-if="departmentlist.length!=0" :collapse="true"></v-jstree>
		</div>
	</div>
</template>
<style scoped>


</style>
<script>
	import VJstree from 'vue-jstree'
	export default {
		props: {

		},
		data() {
			return {
				loading: false,
				departmentlist: [],
				departmentsource: [],
				currentObj: null,
				currentItem: {
					id: 0,
					name: ''
				},
				currentChildren: [],
			}
		},
		created() {
			this.list()
		},
		mounted() {

		},
		watch: {

		},
		computed: {

		},

		methods: {
			list() {
				this.loading = true
				this.departmentlist = []
				if (!window.systemData.department) {
					this.$api.department.list({
						currentPage: -1
					}).then((res) => {
						window.systemData.department = JSON.parse(JSON.stringify(res.list))
						let list = res.list
						list.forEach((item) => {
							item.icon = ''
							
							// if(item.type==1){
							// 	item.icon = 'vxe-icon-company'
							// }else if(item.type==2){
							// 	item.icon = 'vxe-icon-user-fill'
							// }else{
							// 	item.icon = 'vxe-icon-flow-branch'
							// }
							
						})

						let root = []
						list.forEach((item) => {
							if(item.code){
								item.name = item.name+'('+item.code+')'
							}							
							if (item.parentid == 0) {
								root.push(item)
							} else {
								list.forEach((_item) => {
									if (item.parentid == _item.id) {
										if (!_item.children) {
											_item.children = []
										}
										_item.children.push(item)
									}
								})
							}
						})
						this.departmentlist = root
						this.departmentsource = list
						this.loading = false

					})
				} else {
						let list = JSON.parse(JSON.stringify(window.systemData.department))
						list.forEach((item) => {
							item.icon = ''
							//item.selected = true
							// if(item.type==1){
							// 	item.icon = 'vxe-icon-company'
							// }else if(item.type==2){
							// 	item.icon = 'vxe-icon-user-fill'
							// }else{
							// 	item.icon = 'vxe-icon-flow-branch'
							// }
						})

						let root = []
						list.forEach((item) => {
							if(item.code){
								item.name = item.name+'('+item.code+')'
							}
							if (item.parentid == 0) {
								root.push(item)
							} else {
								list.forEach((_item) => {
									if (item.parentid == _item.id) {
										if (!_item.children) {
											_item.children = []
										}
										_item.children.push(item)
									}
								})
							}
						})
						this.departmentlist = root
						this.departmentsource = list
						this.loading = false
				}





			},
			itemClick(node, item, e) {
				this.currentObj = node
				this.currentItem = item
				//console.log(node)
				let parentbread = [{
					id: item.id,
					name: item.name
				}]
				this.createParenBread(item, parentbread)
				//console.log(bread)
				this.currentChildren = [item.id]
				this.findcildren([item.id])
				this.$emit('select', {
					id: item.id,
					name: item.name,
					parentbread: parentbread,
					children: this.currentChildren
				})
				e.stopPropagation()
			},
			updateNode(node) {
				for (let i in node) {
					this.currentItem[i] = node[i]
				}
			},
			addNode(node) {
				this.currentItem.addChild(node)
			},
			removeNode() {
				let index = this.currentObj.parentItem.indexOf(this.currentItem)
				this.currentObj.parentItem.splice(index, 1)
			},
			unSelectNode() {
				this.currentItem.selected = false
				this.currentItem = {
					id: 0,
					name: ''
				}
			},
			// clickBlank() {
			// 	if (this.currentObj) {
			// 		this.currentObj.model.selected = false
			// 		this.$emit('select', {
			// 			id: 0,
			// 			name: ''
			// 		})
			// 	}
			// },
			createParenBread(item, bread) {
				if (item.parentid == 0) {
					return item
				} else {
					for (let i = 0; i < this.departmentsource.length; i++) {
						if (item.parentid == this.departmentsource[i].id) {
							bread.unshift({
								name: this.departmentsource[i].name,
								id: this.departmentsource[i].id
							})
							this.createParenBread(this.departmentsource[i], bread)
						}
					}
				}
			},
			findcildren(departmentids) {
				let childrenid = []
				departmentids.forEach((departmentid) => {
					this.departmentsource.forEach((item) => {
						if (item.parentid == departmentid) {
							childrenid.push(item.id)
						}
					})
				})
				if (childrenid.length != 0) {
					this.currentChildren = this.currentChildren.concat(childrenid)
					this.findcildren(childrenid)
				}
			},
			getdepartmentbyid(id) {
				for (let i = 0; i < this.departmentsource.length; i++) {
					//console.log(this.departmentsource[i].id)
					if (this.departmentsource[i].id == id) {

						return this.departmentsource[i]
					}
				}
				return {
					name: '未知'
				}
			}
		},
		components: {
			VJstree
		}
	}
</script>
